import { Link } from "@inertiajs/react";

import AppLogoIcon from "./app-logo-icon";

export default function AppLogo() {
  return (
    <Link href="/" className="flex items-center gap-3">
      <div className="flex aspect-square size-10 items-center justify-center rounded-xl bg-orange-500">
        <AppLogoIcon className="size-6 text-white" />
      </div>
      <span className="text-2xl font-bold text-orange-600">OG Pilot</span>
    </Link>
  );
}
